import { render } from "./GlobalFootprint.vue?vue&type=template&id=50252291&scoped=true"
import script from "./GlobalFootprint.vue?vue&type=script&lang=js"
export * from "./GlobalFootprint.vue?vue&type=script&lang=js"

import "./GlobalFootprint.vue?vue&type=style&index=0&id=50252291&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50252291"]])

export default __exports__